import React from "react";

const PlusIcon = ({size = "14px", strokeWidth = "1.5"}) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path
      d="M7 1V13M1 7H13"
      stroke="#242424"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export default PlusIcon;
